var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoursesActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IPM/icon/courses-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IPM/icon/courses-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "open-book",
    transform: "translate(2, 5)",
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.97722551,8.81430155e-05 C3.97652517,8.81430155e-05 3.97573729,8.81430155e-05 3.97503695,8.81430155e-05 C3.7291304,8.81430155e-05 3.49784343,0.0966047448 3.32319637,0.272009345 C3.14662339,0.449353092 3.0493638,0.68548823 3.0493638,0.93687211 L3.0493638,14.9837838 C3.0493638,15.4988915 3.46720359,15.9189811 3.98090229,15.9203033 C6.14652574,15.9255037 9.77480732,16.3799691 12.2778191,19.0172963 L12.2778191,4.31680418 C12.2778191,4.14219286 12.2335227,3.97815871 12.1499197,3.84241847 C10.0955626,0.511317632 6.14775134,0.00520043791 3.97722551,8.81430155e-05 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9507237,14.9837838 L22.9507237,0.936783967 C22.9507237,0.685400087 22.8534641,0.449264949 22.6768912,0.271921202 C22.5022441,0.0965166018 22.270782,0 22.0251381,0 C22.0243502,0 22.0235624,0 22.022862,0 C19.8524237,0.00520043791 15.9046125,0.511317632 13.8501678,3.84241847 C13.7665649,3.97815871 13.722356,4.14219286 13.722356,4.31680418 L13.722356,19.0172081 C16.2253678,16.379881 19.8536493,15.9254156 22.0192728,15.9202151 C22.5328839,15.918893 22.9507237,15.4988034 22.9507237,14.9837838 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0697746,3.23952024 L24.395173,3.23952024 L24.395173,14.9837838 C24.395173,16.2989657 23.3309203,17.3714018 22.0226869,17.374663 C20.1857851,17.3790702 17.1569938,17.740721 15.0119428,19.7848457 C18.7218139,18.8702737 22.6326823,19.4647984 24.8615113,19.9762041 C25.1398085,20.0400197 25.4273853,19.9740887 25.6503557,19.7951584 C25.8725383,19.6166688 26,19.3498599 26,19.0634832 L26,4.17612792 C26,3.659698 25.5826855,3.23952024 25.0697746,3.23952024 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60482695,14.9837838 L1.60482695,3.23952024 L0.930225354,3.23952024 C0.417402079,3.23952024 0,3.659698 0,4.17612792 L0,19.0632188 C0,19.3496836 0.127461709,19.6164044 0.349644275,19.794894 C0.572439638,19.9737361 0.859753736,20.0399315 1.13848868,19.9759397 C3.36731773,19.4644458 7.27827366,18.8700093 10.9879697,19.7845812 C8.8430062,17.7405447 5.81421486,17.378982 3.97731305,17.3745749 C2.66916723,17.3714018 1.60482695,16.2989657 1.60482695,14.9837838 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoursesActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/courses-active.87d3beedda0e22f82e37a59e6387f8cc.svg";